<script setup lang="ts">
import type { ComboboxGroupProps } from 'reka-ui'
import { ComboboxGroup, ComboboxLabel } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

const properties = defineProps<
  ComboboxGroupProps & {
    class?: HTMLAttributes['class']
    heading?: string
  }
>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = properties

  return delegated
})
</script>

<template>
  <ComboboxGroup v-bind="delegatedProperties" :class="cn('atabix-combobox-group', properties.class)">
    <ComboboxLabel v-if="heading" class="atabix-combobox-label">
      {{ heading }}
    </ComboboxLabel>
    <slot />
  </ComboboxGroup>
</template>

<style lang="scss">
.atabix-combobox-group {
  @apply overflow-hidden;
  @apply p-1;
  @apply text-foreground;
  @apply overflow-y-scroll;
  @apply max-h-[40vh];
  @apply flex;
  @apply flex-col;
}
</style>
